module.exports = __webpack_public_path__ + "img/phantom-logo.c57b6ee8.png";